import { defineSlotRecipe } from '@chakra-ui/react'

const bgLayer2 = 'bg.layer2.default'

export const customTabs = defineSlotRecipe({
  className: 'CustomTabs',
  slots: ['tabWrap', 'tabList', 'tabListButton', 'tabContent'],
  base: {
    tabListButton: {
      borderRadius: 'var(--chakra-radii-sm) var(--chakra-radii-sm) 0 0',
      textTransform: 'none',
      height: 14,
      p: 'var(--alto-sem-space-sm) var(--alto-sem-space-lg)',
      fontSize: 'var(--alto-sem-text-label-md-font-size)',
      fontWeight: 'medium',
      lineHeight: 'var(--alto-sem-text-label-md-line-height)',
      letterSpacing: 'var(--alto-sem-text-label-md-letter-spacing)',

      marginRight: 'var(--alto-sem-space-5xs)',

      _focusVisible: {
        outlineStyle: 'solid',
        outlineColor: 'border.accent',
        outlineOffset: '2px',
        outlineWidth: '2px',
        position: 'relative',
        marginTop: 2,
        border: 'none',
      },

      '&[aria-current=page]': {
        border: 'none',
        bgColor: 'var(--alto-sem-color-bg-layer2-default)',
        color: 'var(--alto-sem-color-fg-accent-primary)',
      },
    },
    tabWrap: {
      _before: { bgColor: bgLayer2 },
    },
    tabContent: {
      backgroundColor: bgLayer2,
      borderRadius: {
        base: '0',
        md: '0 var(--chakra-radii-xs) var(--chakra-radii-xs) var(--chakra-radii-xs)',
      },
      boxShadow: 'lg',
    },
  },
})
